<div class="smile">
  <ion-row class="smileandsmile">

    <ion-col size="3">
      <ion-icon (click)="rate=10;didRated.emit(10)" color="primary"
        name="happy{{rate === 10 ? '': '-outline'}}">
      </ion-icon>
    </ion-col>

    <ion-col size="3">
      <ion-icon (click)="rate=1;didRated.emit(1)" color="primary"
        name="sad{{rate === 1 ? '': '-outline'}}">
      </ion-icon>
    </ion-col>
    
  </ion-row>
</div>